import React, { ComponentProps, ReactElement } from "react";
import { cls } from "@wss/cls";

type ImageProps = ComponentProps<"img">;

/** @deprecated use `Image` from `@clarkinc/zest-design-system/ui`instead. */
export default function DeprecatedImage(props: ImageProps): ReactElement {
  const { className, ...forwardProps } = props;

  return (
    // eslint-disable-next-line jsx-a11y/alt-text
    <img
      {...forwardProps}
      className={cls(
        "relative",
        className,
        "overflow-hidden after:content-[''] after:w-full after:h-full after:bg-white after:absolute after:top-0 after:left-0 after:block",
      )}
    />
  );
}
